import React, { useEffect, useRef, useState } from 'react';
import * as SliderModule from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import PickUpLearning from '../../views/ResumeCourse/ResumeWhereYouLeft';
import { Box, Typography, Button, Grid, Paper } from "@mui/material";
import { display } from '@mui/system';
import './styles.css'
import { RESUME_LEARNING_STRINGS } from './ResumeLearningConstants';
import { useTranslation } from 'react-i18next';
  


const Slider = SliderModule.default;

const ResumeCourseBox = () => {
  const [apiData, setApidata] = useState([])
  const sliderRef = useRef(null);
  const { t } = useTranslation();

  const settings = {
    dots: false,
    infinite: apiData.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const getCourseData = () => {
    const userDataFromLocalStorage = JSON.parse(
      localStorage.getItem('userData')
    );

    const user_id = userDataFromLocalStorage?.user_id
    const url = process.env.REACT_APP_IBL_AXD_URL + `/api/catalog/milestones/users/last/access/incomplete/courses/?user_id=${user_id}`;
    const token = localStorage.getItem("dm_token");

    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + token,
      },
    })
      .then((response) => {
        return response.json(); 

      })
      .then((data) => {
        setApidata(data?.results)
      })
      .catch((err) => {
        console.log('Fetch error:', err);
      });
  };
  useEffect(() => {
    getCourseData()
  }, [])

  return (
    <>
      {apiData.length ?

        <div className='resumeLearningWrap'>

          <Box className='contentBox'>
            <Typography className='titleResumeCourse' >
              {t(RESUME_LEARNING_STRINGS?.PICK_UP_LEARNING_TITLE)}
            </Typography>

            <div className='button-box'>
              <div className="left-arrow" onClick={() => sliderRef.current?.slickPrev()} >
                <img
                  src='../../images/prev.png'
                  loading="lazy"
                  alt=""
                  className="image-160"
                />
              </div>
              <div className="right-arrow-8" onClick={() => sliderRef.current?.slickNext()}>
                <img
                  src='../../images/next.png'
                  loading="lazy"
                  alt=""
                  className="image-176"
                />
              </div>
            </div>
          </Box>


          {/* Slider */}
          <Slider ref={sliderRef} {...settings}>
            {apiData?.map((text, index) => (
              <div key={index}>

                <PickUpLearning
                  cousedata={apiData[index]}
                  index={index}
                />
              </div>
            ))}
          </Slider>
        </div> : <></>}
    </>
  );
};


export default ResumeCourseBox;
